import { takeEvery, fork, put, call, select } from 'redux-saga/effects';
import i18n from '@/../i18n';

import {
    ActionTypes,
    CheckoutsTermsUpdateAction
} from '@/store/checkoutTerms/types';
import { CheckoutsTermsLoadError,
    CheckoutsTermsLoadSuccess,
    CheckoutsTermsModifySuccess,
    CheckoutsTermsUpdateSuccess,
    getCheckoutsTermsStore
} from '@/store/checkoutTerms/actions';
import { ShowToast } from "@/store/toast/actions";
import { loadCheckoutsTerms, modifyCheckoutsTerms, updateCheckoutsTerms } from '@/services/ApiCategories/checkouts';
import { errorToast } from '@/sagas/commonGenerators/errorToast';

function* loadCheckoutsTermsSaga(): any {
    try {
        const checkoutsTerms = yield call(loadCheckoutsTerms);
        yield put(CheckoutsTermsLoadSuccess({ terms: checkoutsTerms?.data?.Terms, isDefault: checkoutsTerms?.data?.IsDefault }));

    } catch (e) {
        yield call(errorToast, e);
        yield put(CheckoutsTermsLoadError());
    }
}
function* loadCheckoutsTermsWatcher(): any {
    yield takeEvery(ActionTypes.LOAD_START, loadCheckoutsTermsSaga);
}

function* modifyTerms(action: CheckoutsTermsUpdateAction): any {
    try {
        const { payload } = action;
        let response = null;

        const { isDefault } = yield select(getCheckoutsTermsStore);

        if (isDefault) {
            response = yield call(updateCheckoutsTerms, { Terms: payload?.terms, IsDefault: payload?.isDefault });
            yield put(CheckoutsTermsUpdateSuccess({ terms: response?.data?.Terms, isDefault: response?.data?.IsDefault }));
        } else {
            response = yield call(modifyCheckoutsTerms, { Terms: payload?.terms, IsDefault: payload?.isDefault });
            yield put(CheckoutsTermsModifySuccess({ terms: response?.data?.Terms, isDefault: response?.data?.IsDefault }));
        }

        yield put(
            ShowToast({
                message: i18n.t('termssaved'),
                severity: 'info',
                duration: 6000,
            })
        );
    } catch (e) {
        yield call(errorToast, e);
    }
}
function* modifyCheckoutsTermsWatcher(): any {
    yield takeEvery(ActionTypes.UPDATE_START, modifyTerms);
}

const checkoutsTermsSagas = [
    fork(loadCheckoutsTermsWatcher),
    fork(modifyCheckoutsTermsWatcher),
];

export default checkoutsTermsSagas;